import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (timezone && this.hasFieldTarget) {
        this.fieldTarget.value = timezone
      }
    } catch (e) {
      // Fail silently - timezone is optional
    }
  }
}
